var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4081,
    height: 735,
    viewBox: "0 0 4081 735",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M485.588 46.4989L457.684 57.6712C324.39 111.041 237 240.166 237 383.748C237 577.733 394.257 734.99 588.242 734.99L3733.34 734.991C3925.35 734.991 4081 579.338 4081 387.331C4081 242.227 3990.88 112.385 3854.94 61.6312L3806.34 43.4863C3729.45 14.7771 3645.86 9.09262 3565.78 27.1278L3407.69 62.7369C3328.1 80.6612 3245.35 78.8423 3166.63 57.4389L3071.01 31.4382C2993.8 10.4444 2912.68 8.28678 2834.46 25.1465L2647.01 65.5512C2572.33 81.6491 2494.95 80.4193 2420.82 61.9562L2295.27 30.6869C2213.1 10.2232 2127.09 10.9617 2045.28 32.8332L1938.52 61.3778C1844.24 86.5867 1744.64 83.6511 1652 52.9329L1571.78 26.3321C1473.06 -6.40531 1366.58 -7.5393 1267.18 23.088L1148.93 59.5233C1062.91 86.0285 971.325 88.8202 883.848 67.6038L725.911 29.2983C645.963 9.90804 561.959 15.9205 485.588 46.4989Z",
    fill: "url(#paint0_linear_1287_4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M241.105 49.499L220.683 57.6756C87.39 111.045 3.26553e-08 240.17 0 383.751C-4.41231e-08 577.737 157.257 734.993 351.243 734.992L3438.84 734.979C3630.85 734.978 3786.5 579.325 3786.5 387.318C3786.5 242.215 3696.38 112.372 3560.44 61.6181L3511.84 43.4734C3434.95 14.7642 3351.36 9.07973 3271.28 27.1149L3110.8 63.2617C3032.74 80.843 2951.6 79.4342 2874.2 59.1538L2772.42 32.4848C2689.85 10.8498 2603.12 10.7134 2520.48 32.0887L2417.61 58.6977C2338.09 79.2646 2254.74 79.9284 2174.91 60.6304L2026.5 24.7548C1957.62 8.10327 1885.99 6.28436 1816.35 19.4186L1545.32 70.5374C1477.18 83.3876 1407.12 81.9274 1339.59 66.2497L1165.57 25.8554C1090.86 8.51219 1013.16 8.58967 938.481 26.0818L795.952 59.467C710.491 79.4848 621.267 76.653 537.248 51.2562L494.779 38.4188C411.414 13.2195 321.956 17.1269 241.105 49.499Z",
    fill: "url(#paint1_linear_1287_4)",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1287_4",
    x1: 2123.31,
    y1: 734.991,
    x2: 2123.31,
    y2: -8.76483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#276E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30B62E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1287_4",
    x1: 2000,
    y1: 734.988,
    x2: 2000,
    y2: -34.0136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#228C80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BC238"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.bcd112a38777fa688f99b2c3dc7e10a1.svg";
export { ForwardRef as ReactComponent };